import { BrandConfig } from './brandConfig';
import { mainfreightBrandConfig } from './brands/mainfreight/mainfreight_theme';
import { sandfieldBrandConfig } from './brands/sandfield/sandfield_theme';

export const BRAND_CONFIGS: Record<string, BrandConfig> = {
	mainfreight: mainfreightBrandConfig,
	sandfield: sandfieldBrandConfig,
	// add more companies here when needed
};

export const DEFAULT_BRAND_ID = 'sandfield';
